import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=7b75eb48&scoped=true&"
import script from "./RoleTable.vue?vue&type=script&lang=js&"
export * from "./RoleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b75eb48",
  null
  
)

export default component.exports